import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store';
import './scss/style.scss';
import { useAuth } from './context/authContext';

const loading = (
      <div className="pt-3 text-center">
        <div className="sk-spinner sk-spinner-pulse"></div>
      </div>
);

const Home = React.lazy(() => import('./layout/Home'));
const Login = React.lazy(() => import('./views/pages/login'));
const Signup = React.lazy(() => import('./views/pages/signUp'));


const App = () => {
      const { isAuthenticated, isLoading } = useAuth();

      if (isLoading) return loading;

      return (
        <Provider store={store}>
          <BrowserRouter basename="/">
            <React.Suspense fallback={loading}>
              <Routes>
                <Route path="/" element={isAuthenticated ? <Navigate to="/home" /> : <Navigate to="/login" />} />
                <Route path="/home" element={isAuthenticated ? <Home /> : <Navigate to="/login" />} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/login" element={isAuthenticated ? <Navigate to="/home" /> : <Login />} />
                <Route path="*" element={<Navigate to="/" />} />
              </Routes>
            </React.Suspense>
          </BrowserRouter>
        </Provider>
      );
};

export default App;